module.exports = __webpack_public_path__ + "static/media/img9.6e35da99.jpg";